import cx from 'classnames'

import { Heading } from 'blaze-ui/Heading/Heading'
import { TieredUsage } from './components/TieredUsage/TieredUsage'

import Styles from './TieredBilling.module.scss'
import { useEffect, useMemo } from 'react'
import { Spinner } from 'common/Spinner/Spinner'
import { PaymentDetails } from './components/PaymentDetails/PaymentDetails'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { AutopilotDetails } from './components/AutopilotDetails/AutopilotDetails'

export const TieredBilling = observer(() => {
  const workspaceId = useCurrentWorkspaceId()
  const workspace = useCurrentWorkspace()
  const tierUsageStore = useRootStore().tierUsageStore
  const { loading: isStoreLoading, paymentPlans, currentSubscription } = tierUsageStore

  useEffect(() => {
    tierUsageStore.fetch(workspaceId)
  }, [workspaceId, tierUsageStore])

  const paymentPlan = useMemo(() => {
    return paymentPlans?.find((plan) => plan.key === currentSubscription?.plan)
  }, [currentSubscription, paymentPlans])

  const isLoading = isStoreLoading || !paymentPlan || !currentSubscription || !workspace

  if (workspace?.is_virtual_marketer && currentSubscription) {
    return <AutopilotDetails currentSubscription={currentSubscription} />
  }

  return (
    <div className={cx(Styles.container, Styles[currentSubscription?.plan || ''])}>
      <div className={Styles.header}>
        <Heading level={4}>Billing</Heading>
      </div>
      {isLoading ? (
        <div className={Styles.spinnerContainer}>
          <Spinner />
        </div>
      ) : (
        <TieredUsage subscription={currentSubscription} paymentPlan={paymentPlan} />
      )}
      {workspace?.subscription_provider !== 'apple' && (
        <>
          <br />
          <br />
          <Heading level={5}>Payment Details</Heading>
          <div>{<PaymentDetails lastFour={currentSubscription?.card?.last_four} />}</div>
          <div className={Styles.horizontalRuler} />
          <Heading level={5}>Questions</Heading>
          <p className={Styles.questionCopy}>
            Contact us anytime at <a href="mailto:support@blaze.ai">support@blaze.ai</a> or hit the question mark at the
            bottom right corner and chat to us via Intercom.
          </p>
        </>
      )}
    </div>
  )
})
